// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TailwindCss */\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n", "",{"version":3,"sources":["webpack://src/assets/css/tailwind.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,cAAc;AACd,oBAAoB;AACpB,mBAAmB","sourcesContent":["/* TailwindCss */\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
